import { RiRobot2Line } from '@remixicon/react';

import { IconX, Text } from '@spotify-internal/encore-web';
import {
  ChatEventNotificationFragment,
  getTypeOrNull,
} from '@spotify/confidence-graphql';

import { useSubagentPanel } from '../ChatThread/SubagentPanelContext';

import styles from './NotificationMessage.module.css';

type NotificationMessageProps = {
  notification: ChatEventNotificationFragment;
};

export const NotificationMessage = ({
  notification,
}: NotificationMessageProps) => {
  const panel = useSubagentPanel();
  const stopped = notification.childChatStopped;
  if (!stopped) return null;

  const childChat = getTypeOrNull(stopped.childChat);
  const success = stopped.success ?? true;

  const childTitle = childChat?.displayName ?? 'Subagent';
  const statusLabel = success ? 'finished' : 'failed';

  const label = (
    <Text variant="bodySmall" semanticColor="textSubdued">
      {childChat && panel ? (
        <span
          className={styles.link}
          role="button"
          tabIndex={0}
          onClick={e => {
            e.stopPropagation();
            panel.openSubagentPanel(childChat.name);
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              panel.openSubagentPanel(childChat.name);
            }
          }}
        >
          {childTitle}
        </span>
      ) : (
        childTitle
      )}
      {` ${statusLabel}`}
    </Text>
  );

  return (
    <div className={styles.root}>
      <div className={styles.headerStatic}>
        <RiRobot2Line size={14} className={styles.icon} />
        {!success && <IconX size="xsmall" className={styles.failureIcon} />}
        {label}
      </div>
    </div>
  );
};
